import { CreateCheckListModelTaskDTO } from '../CheckListModelTask/CreateCheckListModelTaskDTO';
import Joi from "joi";

export interface CreateCheckListModelDTO {
  title: string;
  brand?: string | null;
  model?: string | null;
}

export const CreateCheckListModelDTOSchema = Joi.object({
  title: Joi.string()
    .required()
    .messages({
      "string.base": "O título deve ser um texto",
      "any.required": "O título é obrigatório",
      "string.empty": "O título não pode ser vazio",
    }),
  brand: Joi.string()
    .allow(null, "")
    .max(60)
    .when('model', { // quando 'model' satisfazer a condição abaixo
      is: Joi.string().min(1).required(), // model não vazio
      then: Joi.string()
        .required()
        .messages({
          "any.required": "A marca é obrigatória quando o modelo é providenciado",
          "string.empty": "A marca não pode ser vazia quando o modelo é providenciado",
        }),
      otherwise: Joi.string()
        .allow(null, "")
    })
    .messages({
      "string.base": "A marca deve ser um texto",
      "string.max": "A marca não pode ter mais de 60 caracteres",
    }),
  model: Joi.string()
    .allow(null, "")
    .max(60)
    .messages({
      "string.base": "O modelo deve ser um texto",
      "string.max": "O modelo não pode ter mais de 60 caracteres",
    }),
});
